import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18next";

import { USER_INFO_QUERY_KEY } from "Auth/Api/Queries/useUserInfoQuery";
import { JWT_KEY } from "Auth/Models/AuthConstants";
import {
  type FetchResponseOfError,
  patchUsersSettings,
  postAuthSignIn,
  type SignInRequest,
} from "Infrastructure/Api/Api";
import {
  ApiCallError,
  isErrorStatus,
  isSuccessResponse,
} from "Infrastructure/Api/ApiUtils";
import {
  detectBrowserLanguageCode,
  languageCodeToI18n,
} from "Infrastructure/Utils/LanguageUtils";

export function useSignInMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: SignInRequest) => postAuthSignIn(request),
    onSuccess: (data) => {
      if (isErrorStatus(data)) {
        throw new ApiCallError(data as unknown as FetchResponseOfError);
      }

      if (isSuccessResponse(data)) {
        localStorage.setItem(JWT_KEY, `Bearer ${data.data.userInfo.token}`);

        const userLanguage = data.data.userInfo.language;
        if (userLanguage) {
          i18n.changeLanguage(languageCodeToI18n(userLanguage));
        } else {
          const detected = detectBrowserLanguageCode();
          i18n.changeLanguage(languageCodeToI18n(detected));
          patchUsersSettings({ language: detected });
        }
      }

      queryClient.invalidateQueries({ queryKey: [USER_INFO_QUERY_KEY] });
    },
  });
}
